export default __webpack_public_path__ + "static/project-slide-6-2016-765-8c413e5641282aa7141acf6df12c420d.jpg";